import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class FeedbackRestraints extends AdminOnlyItemRestraints {
  canCreateItem(item) {
    return true;
  }
}